import { useEffect } from 'react';

const FACE_IDS = ['rex','roger','aria','xavier','catalyst','koda','nova','echo','sage','phoenix','atlas','lyra','orion'];

export default function EmbedWrapper({ module, children }) {
  useEffect(() => {
    try { window.parent.postMessage({ type: 'FEDERATION_EMBED_READY', pillar: 'keys', module: module }, '*'); } catch(e) {}
  }, [module]);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 flex flex-col" style={{ minWidth: 300 }}>
      <div className="flex-1">{children}</div>
      <div className="border-t border-slate-800/30 py-2 px-3 flex items-center justify-center gap-1.5">
        {FACE_IDS.map(function(id) {
          return (
            <div key={id} className="w-2.5 h-2.5 rounded-full bg-cyan-700/60 flex-shrink-0" title={id} />
          );
        })}
        <span className="text-[8px] text-slate-700 ml-2">KEYS</span>
      </div>
    </div>
  );
}
